export const PROJECT_WON_STATUS = "REALISATION";
export const VALIDATION_REQUIRED_TYPES = () => typeOptions.filter(type => type.validation_required).map(type => type.value);

export const typeOptions = [
    { label: "Étude", value: "étude", validation_required: false },
    { label: "Contrôle", value: "contrôle", validation_required: false },
    { label: "Étude et Contrôle", value: "étude et contrôle", validation_required: false },
    { label: "Éssai Labo", value: "éssai labo", validation_required: true },
];